// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GMnc","question":"styles_question__gYLJb","description":"styles_description__1JKgQ"};